import cSpinner from '#themes/default/default/components/spinner/spinner.js';

import template from './paymentGatewayReturn.html' with { type: 'html' };

export default {
	components: {
		cSpinner
	},
	computed: {
		query() {
			return this.$store.state.route.query || {};
		}
	},
	mounted() {
		if (/success|failure/i.test(this.query.paymentStatus)) {
			// Tell the upper iframe (paymentGatewayIframe) that provided status was received
			window.parent.postMessage({
				type: 'checkout-payment_provider-status',
				payload: this.query.paymentStatus
			});
		}
	},
	template
};
